import { combineEpics } from 'redux-observable';
import { roadmapEpic } from '../epics/roadmapEpic';
export const rootEpic = combineEpics(roadmapEpic);
